import classNames from 'classnames'

import Button from '../Button'

import * as styles from './Select.module.css'

function Select({ className, error, ...restProps }) {
  const buttonClassName = classNames(styles.select, className, {
    [styles.error]: error,
  })

  return <Button {...restProps} className={buttonClassName} />
}

export default Select
